import React, { useEffect } from 'react';
import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';
import { Spinner } from 'react-bootstrap';

const LazyMonacoEditor = React.lazy(() => import('@monaco-editor/react'));

const MonacoEditorComponent = (props) => {
  useEffect(() => {
    loader.config({ monaco });
  }, []);

  //function to handle make editable custom menu option for providing ability of addig markers by selecting specific text 
  const handleEditorDidMount = (editor, monaco) => {
    editor.addAction({
      id: 'custom-action',
      label: 'Make Editable',
      contextMenuGroupId: 'navigation',
      contextMenuOrder: 1.5,
      precondition: 'editorHasSelection', 
      run: function (ed) {
        const selection = ed.getSelection(); // Get selection range
        const model = ed.getModel(); // Get editor model
        const selectedText = model.getValueInRange(selection);

        const firstLineMatch = selectedText.match(/^[ \t]*/);

        //counting leading spaces before start marker to maintain the count of spaces after text updation
        const leadingSpacesCount = firstLineMatch ? firstLineMatch[0].length : 0;

        // Defining the boundary markers
        const startMarker = "/* --- Start of student code, Don't Remove or edit these markers --- */\n";
        const endMarker = "/* --- End of student code, Don't Remove or edit these markers --- */";

        // Replacing the selected text with the new wrapped text
        const modifiedText = " ".repeat(leadingSpacesCount)+`${startMarker}${selectedText}` + "\n" + " ".repeat(leadingSpacesCount)+`${endMarker}`;

        // Applying the replacement
        ed.executeEdits("boundaryInsertion", [
          {
            range: selection,
            text: modifiedText,
            forceMoveMarkers: true,
          },
        ]);
      }
    });
  };

  return (
    <React.Suspense fallback={<div className='d-flex justify-content-center align-items-center'><Spinner size='sm' /></div>}>
      <LazyMonacoEditor
        {...props}
        // Attach the custom menu option on editor mount
        onMount={handleEditorDidMount} 
      />
    </React.Suspense>
  );
};

export default MonacoEditorComponent;
